module.exports = __webpack_public_path__ + "img/CUADRO-M-UP.c146a499.png";